import { Group } from "@mantine/core"
import dayjs from "dayjs"
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import BookingsCalendar from "src/components/calendar/BookingsCalendar"
import { useCalendar } from "src/components/calendar/CalendarContext"
import { CalendarSidebar } from "src/components/calendar/CalendarSidebar"
import { CalendarWrapper } from "src/components/calendar/CalendarStyles"
import { CreateSuperAdminBookingAction } from "src/components/superadmin/bookings/SuperAdminBookingActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayoutCalendar } from "src/components/ui/PageLayoutCalendar"
import { useActions, useAppState } from "src/state"
import { Booking_Status_Enum, BookingFragment, SyncGetBookingsSubscriptionVariables } from "src/state/gql/_types"

export function SuperAdminBookingsCalendar() {

    const navigate = useNavigate()
    const location = useLocation()
    const { itemsList } = useAppState(state => state.bookings)
    const { itemsList: blackoutsList } = useAppState(state => state.blackouts)
    const { subscribeToAllItems, unsubscribeFromAllItems } = useActions().bookings
    const { subscribeToAllItems: subscribeToAllBlackouts, unsubscribeFromAllItems: unsubscribeFromAllBlackouts } = useActions().blackouts
    const { dateRange, talentFilter, venueFilter } = useCalendar();

    const query = React.useMemo<SyncGetBookingsSubscriptionVariables>(() => {
        let newQuery: SyncGetBookingsSubscriptionVariables = {
            where: {
                date: {
                    _gte: dayjs(dateRange.start).format('YYYY-MM-DD'),
                    _lte: dayjs(dateRange.end).format('YYYY-MM-DD')
                },
                _and: [
                    { status: { _neq: Booking_Status_Enum.Deleted } }
                ]
            }
        }
        if (!!newQuery.where && talentFilter.length > 0) {
            newQuery.where._and!.push({
                _or: [
                    { talent_id: { _nin: talentFilter } },
                    { talent_id: { _is_null: true } }
                ]
            })
        }   
        if (!!newQuery.where && venueFilter.length > 0) {
            newQuery.where._and!.push({
                _or: [
                    { venue_id: { _nin: venueFilter } },
                    { venue_id: { _is_null: true } }
                ]
            })
        }
        return newQuery
    }, [dateRange, talentFilter, venueFilter])

    React.useEffect(() => {
        subscribeToAllItems(query);
        return () => {
            unsubscribeFromAllItems()
        }
    }, [query, subscribeToAllItems, unsubscribeFromAllItems])

    React.useEffect(() => {
        subscribeToAllBlackouts({});
        return () => {
            unsubscribeFromAllBlackouts()
        }
    }, [query, subscribeToAllItems, unsubscribeFromAllItems])


    const onEventClick = (booking: BookingFragment) => {
        navigate(`/bookings/${booking.id}`, { state: { drawerFrom: location } })
    }

    return (
        <PageLayoutCalendar
            header={
                <PageHeader
                    title={`Bookings`}
                    renderAction={
                        <Group>
                            <CreateSuperAdminBookingAction />
                        </Group>
                    }
                />
            }
        >

            <CalendarWrapper>

                <CalendarSidebar />

                <BookingsCalendar
                    bookings={itemsList}
                    blackouts={blackoutsList}
                    onEventClick={onEventClick}
                />

            </CalendarWrapper>

        </PageLayoutCalendar>
    )

}